import Api from "./Api";
export default {
  sendInvoicePayment(obj) {
    return Api().post("sendInvoicePayment", obj);
  },
  delevires(docId) {
    return Api().get(`delevires/${docId}`);
  }
};
